import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { FeatureFlagService } from '../../feature-flag.service';
import { LanguageService } from '../../language.service';
import { AuthService } from '../../services/auth.service';
import { NotificationsSidenavService } from '../../services/notifications-sidenav.service';
import { SidenavService } from '../../services/sidenav.service';
import { Nav } from '../../_nav';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit, OnDestroy {

  public currentLanguage: string;

  public navItems = new Nav();

  public menu: any[];

  private activateButtons = true;

  private langSub: Subscription;

  public notificationsPanelWidth: string;

  watcher: Subscription;

  public showSubmenu: boolean;

  public currentHoveredItem: string;

  @ViewChild('sidenav', { static: true }) public sidenav: MatSidenav
  @ViewChild('notificationsSidenav', { static: true }) public notificationsSidenav: MatSidenav;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(
    [
      Breakpoints.Handset,
      Breakpoints.Web,
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait,
      Breakpoints.Large,
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.Tablet,
      Breakpoints.TabletLandscape,
      Breakpoints.TabletPortrait,
      Breakpoints.WebLandscape,
      Breakpoints.WebPortrait
    ])
    .pipe(
      map(result => result.matches)
    );

  isSmallHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));

  //private authService: AuthService
  constructor(
    private featureFlagService: FeatureFlagService,
    private translateService: LanguageService,
    private sidenavService: SidenavService,
    private notificationsSidenavService: NotificationsSidenavService,
    private authService: AuthService,
    private mediaObserver: MediaObserver,
    private breakpointObserver: BreakpointObserver,
    router: Router
  ) {
    this.menu = []
    this.watcher = this.mediaObserver.media$.subscribe((change: MediaChange) => {
      this.notificationsPanelWidth = change.mqAlias;
    });

    router.events.pipe(
      withLatestFrom(this.isHandset$),
      filter(([a, b]) => b && a instanceof NavigationEnd)
    ).subscribe(_ => {
      this.sidenav.close()
      this.notificationsSidenav.close()
    });
  }

  ngOnInit() {
    this.langSub = this.translateService.currentLanguage.subscribe(
      res => { this.currentLanguage = res }
    )

    this.activateButtons = (this.authService.isLoggedInAndAdmin || this.authService.isLoggedInCustomerAdmin)
    this.sidenavService.setSidenav(this.sidenav);
    this.notificationsSidenavService.setSidenav(this.notificationsSidenav)
    this.createSidenavMenu()
    this.showSubmenu = false;
  }

  generateSidenavClass() {
    let width: string;
    switch (this.notificationsPanelWidth) {
      case "xs":
        return width = "w-75";
      case "sm":
        return width = "w-75";
      case "md":
        return width = "w-50";
      case "lg":
        return width = "w-50";
      case "xl":
        return width = "w-45";
    }
  }

  logout() {
    this.authService.logout();
  }

  createSidenavMenu() {
    this.menu = [...this.navItems.navItems]

    this.menu = this.menu.filter(item => {
      if (this.featureFlagService.featureOn(item.url)) {
        if (this.authService.isLoggedInMunicipalPolice || this.authService.isLoggedInSimpleUser) {
          return item.url !== 'users-management/all-users' && item.url !== 'rules'
        } else if (this.authService.isLoggedInAndAdmin || this.authService.isLoggedInCustomerAdmin) {
          return item
        } else {
          return item
        }
      }
      return
    })
  }
  changeSubmenuVisibility(e: any, item?: string) {
    if (e.type == 'mouseover') {
      this.currentHoveredItem = item; 
      this.showSubmenu = item === this.currentHoveredItem;
    } else {
      this.currentHoveredItem = '';
      this.showSubmenu = false;
    }
  }
  
  ngOnDestroy() {
    if (this.langSub) this.langSub.unsubscribe();
  }
}
